import React, { useContext } from 'react'
import "./VehicleProgressBreadCrumb.css"

const breadcrumb = {
    borderRadius: '0.37rem',
    "--bs-breadcrumb-divider": "''",
    textDecoration: 'none'
}

const VehicleProgressBreadCrumb = (props) => {
    const context = useContext(props?.requestContext)
    var requestClass = (props?.endorsementType == "RemoveVehicle") ? "removeVehicleClass" : (props?.endorsementType == "ReplaceVehicle") ? "replaceVehicleClass" : "addVehicleClass"
    const navs =
        [
            '1. Vehicle',
            '2. Driver Assignment',
            '3. Confirm',
            '4. Summary'
        ]
    const noDriverAssignmentNavs = 
        [
            '1. Vehicle',
            '2. Confirm',
            '3. Summary'
        ]

    const isCurrent = ((value) => {
        const screen = props?.screen === undefined ? context[requestClass]?.screenName : props?.screen;
        return value.slice(3) === screen;
    });
    
    return (
        <>
            <div className="clearfix"></div>

            {/* Vehicle Progress Bar */}
            <div className="col-12">
                <nav>
                    <ol className="breadcrumb justify-content-center" style={breadcrumb}>
                        {(props?.endorsementType == "RemoveVehicle") && context[requestClass]?.vehicles?.vehiclesOnPolicy?.storedVehicles.length == 1 ? <>
                            {
                            noDriverAssignmentNavs.map((nav, navIndex) => {
                                const active = isCurrent(nav) ? 'fw-bold text-blue' : 'disabled';
                                return (
                                    <li key={navIndex} className="breadcrumb-item align-items-center d-flex">
                                        <button className={`btn ${active}`}>
                                            {nav}
                                        </button>
                                    </li>
                                );
                            })
                            }
                            </>
                            :<>
                            {
                            navs.map((nav, navIndex) => {
                                const active = isCurrent(nav) ? 'fw-bold text-blue' : 'disabled';
                                return (
                                    <li key={navIndex} className="breadcrumb-item align-items-center d-flex">
                                        <button className={`btn ${active}`}>
                                            {nav}
                                        </button>
                                    </li>
                                );
                            })
                            }
                        </>}
                        
                    </ol>
                </nav>
            </div>

        </>
    )
}

export default VehicleProgressBreadCrumb

